<template>
  <div style="padding:2rem">
    <v-container>
      <v-form
          ref="form"
          lazy-validation
      >
        <h2 class="mt10 pt10">CORDON DE SERRAGE</h2>
        <br/><br/>
        <v-row>
          <v-col cols="12" sm="12">
            <table border="0" class="dimensions">
              <tbody v-for="(label, index) in labels" :key="label.value">
              <tr>
                <td>{{ label.label }}</td>
                <td>
                  <Vminusplusfield
                      :index="index"
                      :max="10"
                      :min="0"
                      :price="label.price"
                      :value="detailQte[index]"
                      @input="getInfos"
                  />
                </td>
              </tr>
              <tr>
                <td v-if="label.value === 'remplacer' && detailQte[index] > 0" colspan="2">
                  <v-checkbox
                      v-model="replaceBlock"
                      :false-value="false"
                      :true-value="true"
                      label="Je veux remplacer le bloqueur / stop cordon"
                  />
                </td>
              </tr>
              </tbody>
            </table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <div class="spacer"></div>
            <br/><br/>
            <h6>EMPLACEMENT</h6>
            <v-textarea
                v-model="emplacement"
                name="input-7-4"
                outlined
                placeholder="Indiquez l'emplacement"
                rows="3"
                counter="150"
                maxlength="150"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <price :amount="price" :display-bottom-line="totalQty > 0"/>
          </v-col>
        </v-row>
        <confirm-flow
            v-if="totalQty > 0 && !this.flux.indexEditProduit"
            @finalize="noarticle"
            @new-repair="onSelectNewRepair"
            @new-article="noarticle(false)"
        />
        <v-row v-else-if="this.flux.indexEditProduit">
          <v-col v-if="error" cols="12">
            <div class="text-center" style="color:#FF0000">Vous devez selectionner la quantité de cordons de serrage à
              réparer
            </div>
          </v-col>
          <v-col class="text-center" cols="12">
            <div class="btn btn-1 text-center btn-size" @click="noarticle">MODIFIER</div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <span style="display:none">{{ flux.actionId }}</span>
  </div>
</template>
<script>
import prices from '../../assets/data/price/cordon-serrage.json';
import {mapMutations, mapState} from 'vuex'
import Vminusplusfield from '../interface/PlusMinusField.vue'
import Price from "@/components/shared/Price.vue";
import ConfirmFlow from "@/components/shared/ConfirmFlow.vue";

let liste_reparations = []

export default {
  data() {
    return {
      emplacement: null,
      hasBtn: false,
      price: 0,
      oneUpdate: false,
      totalQty: 0,
      error: false,
      detailQte: [0, 0],
      detailPrice: [0, 0],
      labels: [],
      replaceBlock: false,
      replaceBlockPrice: 0
    }
  },
  created() {
    this.labels = prices[this.flux.level2].labels
    this.replaceBlockPrice = prices[this.flux.level2].replace_block_price
    //Recup valeur champ si mode Edition
    if (this.flux.indexEditProduit !== null) {
      this.emplacement = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['emplacement']
      this.hasBtn = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['hasBtn']
      this.price = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['price']
      this.totalQty = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['qteFinal']
    }
  },
  updated() {
    if (this.flux.componentName !== 'cordon-serrage') {
      return null;
    }
    //Recup valeur champ si mode Edition
    if (this.flux.level2 && this.flux.verrou === false && this.flux.indexEditProduit !== null) {
      this.setVerrou(true)
      this.emplacement = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['emplacement']
      this.hasBtn = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['hasBtn']
      this.price = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['price']
      this.totalQty = this.products[this.flux.indexEditProduit]['reparations'][this.flux.indexEditReparation]['qteFinal']
    }
  },
  computed: {
    ...mapState('cart-app', ['cards', 'products']),
    ...mapState('flux-app', ['flux']),
  },
  watch: {
    replaceBlock() {
      this.getInfos([1, this.detailQte[1], this.labels[1].price * this.detailQte[1]])
    }
  },
  methods: {
    ...mapMutations('flux-app', ['setConstat', 'setCptProduct', 'setcptReparation', 'setVerrou', 'setLevel1', 'setLevel2', 'setLevel3', 'setComponentName']),
    ...mapMutations('cart-app', ['addProduct', 'getTotalCart']),
    editRepair(indexes) {
      this.$emit('edit', indexes)
    },
    evenement(value) {
      if (value == 'scroll3') {
        this.$scrollTo('#screen3')
      }
      if (value == 'scroll1') {
        this.$scrollTo('#screen1')
      }
    },
    noarticle(showCart = true) {
      if (this.price <= 0) {
        this.error = true;
      } else if (this.$refs.form.validate()) {
        if (this.flux.indexEditProduit !== null) { //Mode Edit
          this.editProduct();
          this.setLevel1(null)
          this.setLevel2(null)
          this.setLevel3(null)
          this.setComponentName(null)
        } else {
          this.storeProduct()
          this.setCptProduct(this.flux.cptProduct + 1)
          liste_reparations = []
          this.setcptReparation(0)
        }

        this.$emit('evenement', 'scroll1')

        if (showCart) {
          this.showModal('cart')
        }
      }
    },
    onSelectNewRepair() {
      this.storeProduct()
      this.$emit('evenement', 'scroll3')
    },
    editProduct() {
      liste_reparations = this.products[this.flux.indexEditProduit].reparations
      //On check l'historique des réparations
      let index = liste_reparations.findIndex((obj => obj.id == (this.flux.indexEditReparation + 1)));
      if (index > -1) {
        let reparation = {
          id: liste_reparations[index].id,
          type: 'Cordon de serrage',
          componentName: 'cordon_serrage',
          emplacement: this.emplacement,
          hasBtn: this.hasBtn,
          qteFinal: this.totalQty,
          price: this.price,
          qte: 1
        }

        this.products[this.flux.indexEditProduit].reparations.splice(index, 1, reparation)

        let data = {
          idLevel1: this.products[this.flux.indexEditProduit].idLevel1,
          level1: this.products[this.flux.indexEditProduit].level1,
          level2: this.products[this.flux.indexEditProduit].level2,
          level3: this.products[this.flux.indexEditProduit].level3,
          isDouble: this.products[this.flux.indexEditProduit].isDouble,
          id: this.products[this.flux.indexEditProduit].id,
          name: this.products[this.flux.indexEditProduit].name,
          famille: this.products[this.flux.indexEditProduit].famille,
          reparations: liste_reparations
        }


        this.addProduct(data)
        this.getTotalCart(this.products)
        this.$emit('evenement', 'scroll3')

      }
    },
    storeProduct() {
      if (this.price <= 0) {
        this.error = true;
      } else if (this.$refs.form.validate()) {
        this.setcptReparation(this.flux.cptReparation + 1)

        if (this.flux.cptProduct < 1) {
          this.setCptProduct(this.flux.cptProduct + 1)
        }

        //On check l'historique des réparations
        liste_reparations = []
        let index = this.products.findIndex((obj => obj.id == this.flux.cptProduct));
        if (index > -1) {
          liste_reparations = this.products[index].reparations
        }

        let emplacement = this.emplacement ?? '';
        if (this.replaceBlock && this.detailQte[1] > 0) {
          emplacement = `${emplacement.length > 0 ? '<br />' : ''}Je veux remplacer le bloqueur / stop cordon`
        }

        const details = [
          this.detailQte,
          this.detailPrice
        ]
        const elements = [{labels: this.labels.map(label => label.label)}]

        let reparation = {
          id: this.flux.cptReparation,
          type: this.flux.level3,
          componentName: 'cordon-serrage',
          emplacement,
          hasBtn: this.hasBtn,
          qteFinal: this.totalQty,
          price: this.price,
          qte: 1,
          details,
          elements
        }

        liste_reparations.push(reparation)

        let data = {
          idLevel1: this.flux.idLevel1,
          level1: this.flux.level1,
          level2: this.flux.level2,
          level3: this.flux.level3,
          isDouble: this.flux.isDouble,
          id: this.flux.cptProduct,
          name: this.flux.level2,
          famille: this.flux.level1,
          reparations: liste_reparations
        }
        this.addProduct(data)
        this.getTotalCart(this.products)
        this.setLevel3(null)
        this.setComponentName(null)
      }
    },
    showModal(constat) {
      this.setConstat(constat)
      this.$emit('showmodal', this.flux.level2)
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getInfos(value) {
      this.totalQty = 0
      this.$set(this.detailQte, value[0], value[1])

      if (this.replaceBlock && value[0] === 1 && value[1] > 0) {
        this.$set(this.detailPrice, value[0], value[2] + (this.replaceBlockPrice * value[1]))
      } else {
        this.$set(this.detailPrice, value[0], value[2])
      }

      for (let i = 0; i < this.detailQte.length; i++) {
        this.totalQty += this.detailQte[i]
      }

      this.error = false
      this.getPrice()
    },
    getPrice() {
      this.price = 0
      for (let i = 0; i < this.detailPrice.length; i++) {
        this.price += this.detailPrice[i]
      }

      this.price = Math.round(this.price * 100) / 100
      this.error = false
    }
  },
  components: {
    ConfirmFlow,
    Price,
    Vminusplusfield
  }
}
</script>
<style scoped>
table {
  max-width: 390px;
}

table td.picto, table td.picto img {
  width: 100px;
}

table td.picto {
  padding: 20px 20px 20px 0;
}

.btn {
  background-color: #000;
  width: 120px;
  padding: 10px;
  color: #fff
}

.grey {
  background-color: #F8F8F8 !important;
}
</style>
